import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'
import { useGetDocuments } from 'core/hooks/api'

// Styled Elements
import { TableWrapper } from './AiDocumentTable.elements'

// Assets
import { PlusWhiteIcon } from 'assets/images/Icons'

// Views
import { CardTable, EmptyTablePlaceholder, LoadingTablePlaceholder, Button } from 'views/components'

import AiDocumentTableItem from '../AiDocumentTableItem'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function AiDocumentTable(props) {
  // Destructure
  const { filters, actions, ui } = props

  // Store States
  const { aiDocumentFilters } = filters
  const { isPageTableUpdated } = ui

  // Store Actions
  const { setAiDocumentFilters, setIsPageTableUpdated, setIsAiDocumentUploadModalOpen } = actions

  // Variables
  const { sort, page, size } = aiDocumentFilters

  // States
  const [documents, setDocs] = useState({ items: [], total: 0 })

  // Hooks
  const [userCredentials] = useLocalStorage('userCredentials', false)
  const { getDocumentsData, getDocuments, isGetDocumentsLoading } = useGetDocuments()

  // Functions
  const fetchDocs = () => {
    getDocuments({
      biz_id: userCredentials.Business_ID,
      sort,
      page,
      size,
    })
  }

  // UseEffects
  useEffect(() => {
    if (getDocumentsData) {
      setDocs({ items: getDocumentsData?.items, total: getDocumentsData?.pagination?.total })
    }
  }, [getDocumentsData])

  useEffect(() => {
    if (aiDocumentFilters || isPageTableUpdated) {
      fetchDocs()
      setIsPageTableUpdated(false)
    }
  }, [aiDocumentFilters, isPageTableUpdated])

  console.log('CALLED')
  return (
    <TableWrapper>
      <CardTable
        totalItems={documents.total}
        minWidth={900}
        cardWidth={500}
        // filterComponents={<VaspTableFilter />}
        tableFilters={aiDocumentFilters}
        setTableFilters={setAiDocumentFilters}
        headerOptions={
          <Button
            size="small"
            startIcon={<PlusWhiteIcon size={18} />}
            onClick={() => setIsAiDocumentUploadModalOpen(true)}
          >
            Document
          </Button>
        }
      >
        {documents.items.length > 0 && !isGetDocumentsLoading ? (
          documents.items.map((details) => <AiDocumentTableItem key={details?.id} details={details} />)
        ) : (
          <div>
            {isGetDocumentsLoading ? (
              <LoadingTablePlaceholder />
            ) : (
              <EmptyTablePlaceholder setFilter={setAiDocumentFilters} />
            )}
          </div>
        )}
      </CardTable>
    </TableWrapper>
  )
}

// Default Props
AiDocumentTable.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
AiDocumentTable.propTypes = {
  filters: PropTypes.shape({
    aiDocumentFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
  actions: PropTypes.shape({
    setAiDocumentFilters: PropTypes.func,
    setToBeUpdatedVasp: PropTypes.func,
    setIsAiDocumentUploadModalOpen: PropTypes.func,
    setIsEntityVaspDrawerOpen: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(AiDocumentTable)
